import styled from 'styled-components'
import { BP } from 'resources/constants'
import { cmsTextBlockCss, cmsSectionHeroCss } from '../../../../components/Styled'
import { facebookButton } from 'app/sofia/resources/theme/css'

export const CmsContentWrap = styled.div`
  --txtBoxSidePad: 10vw;

  a {
    ${props => props.theme.css.link};

    &.fb-btn {
      ${facebookButton}
    }
  }

  .section {
    ${cmsSectionHeroCss}

    .text-box {
      ${cmsTextBlockCss}
      padding: 20px 10px;

      @media (min-width: ${BP.sm.min}) {
        padding: 30px;
      }

      @media (min-width: ${BP.md.min}) {
        display: flex;
        padding: 0 !important;

        > div {
          flex-basis: 100%;
        }
      }
    }

    &.our-story-section-1 {
      .container {
        @media (max-width: ${BP.md.max}) {
          background: #a0d8e5;
        }
      }

      .text-box {
        @media (max-width: ${BP.md.max}) {
          padding-top: 15px;
          padding-bottom: 0;
        }

        > div:first-child {
          @media (min-width: ${BP.md.min}) {
            padding-right: var(--txtBoxSidePad);
            padding-bottom: 2.25vw;
          }
        }
      }
    }

    &.our-story-section-2 {
      .container {
        @media (max-width: ${BP.md.max}) {
          background: #ca89a1;
        }
      }

      .text-box {
        @media (max-width: ${BP.md.max}) {
          padding-top: 0;
          padding-bottom: 10px;

          @media (min-width: ${BP.sm.min}) {
            padding-top: 0;
            padding-bottom: 15px;
          }
        }

        > div:last-child {
          @media (min-width: ${BP.md.min}) {
            padding-left: var(--txtBoxSidePad);
            padding-bottom: 6vw;
          }

          .header,
          .header em,
          p {
            color: #fff;
          }
        }
      }
    }

    &.our-story-section-3 {
      @media (min-width: ${BP.md.min}) {
        z-index: 2;
      }

      .text-box {
        @media (max-width: ${BP.md.max}) {
          padding-top: 15px;
          padding-bottom: 20px;
        }

        > div:first-child {
          @media (min-width: ${BP.md.min}) {
            padding-right: var(--txtBoxSidePad);
            padding-bottom: 2vw;
          }
        }
      }
    }

    .flower {
      position: absolute;
      z-index: 1;
      overflow: hidden;
      display: none;

      @media (min-width: ${BP.md.min}) {
        display: block;
      }

      &.flower-4 {
        width: 150px;
        bottom: -100px;
        right: 0;

        img {
          width: 200px;
        }
      }

      &.flower-5 {
        width: auto;
        top: -200px;
        right: 0;

        @media (min-width: ${BP.lg.min}) {
          top: -250px;
        }

        img {
          width: 220px;
          right: -70px;
          position: relative;

          @media (min-width: ${BP.lg.min}) {
            width: 300px;
            right: -100px;
          }
        }
      }
    }
  }
`
